import { Component, HostListener, Inject, Renderer2 } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { AppConfig, APP_CONFIG } from '../app.config';
import { globalConstants } from './components/shared/global-constants';
import { HeaderComponent } from './components/shared/header/header.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { initPsicIcons } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { LoadingComponent } from './components/shared/loading/loading.component';
import { NotificationCardComponent } from './components/shared/notification-card/notification-card.component';
import { GoBackService } from './services/go-back.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        HeaderComponent,
        LoadingComponent,
        NotificationCardComponent
    ],
    providers: [DatePipe],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'instantpay';
  isAuthenticated: boolean = false;

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private renderer: Renderer2,
    private contexts: ChildrenOutletContexts,
    private iconReg: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private goBackService: GoBackService,
  ) {
    // Theme setup
    const storedTheme = localStorage.getItem('selectedTheme');
    if (storedTheme && !this.config.production) {
      this.selectedTheme = storedTheme;
    }
    this.applyTheme(this.selectedTheme);

     iconReg.addSvgIconResolver((name: string) =>
      sanitizer.bypassSecurityTrustResourceUrl(`/assets/images/themes/${this.selectedTheme}/${name}.svg`)
    );
    
    initPsicIcons(this.sanitizer, this.iconReg)
  }

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: any) {
    if (!this.config.useMock && this.goBackService.beforeUnloadAlert) 
      event.returnValue = false;
  }

  async ngOnInit() {
    // Initialize authentication state if needed
  }

  getTriggerState(): any {
        return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
  }

  selectedTheme: string = this.config.theme;
  onThemeChange(theme: string) {
      this.selectedTheme = theme;
      this.applyTheme(theme);
      window.location.reload();
  }

  private applyTheme(theme: string) {
      globalConstants.themeList.forEach(className => document.body.classList.remove(className));
      this.renderer.addClass(document.body, theme);
  }
}